export enum MessageStateType {
  Enter = 'enter',
  Visible = 'visible',
  Leave = 'leave',
}
